module.exports = __webpack_public_path__ + "fonts/icons.svg"


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-css/themes/default/assets/fonts/icons.svg
 ** module id = 382
 ** module chunks = 0
 **/